// Shared accessible typography for ECharts. The `vertice-light` / `vertice-dark`
// themes (theme.ts) already set axis tick + legend defaults to 12px with
// WCAG-AA contrast. This module covers what a registered theme cannot express:
// per-series `label` styling, dense-axis rotation/thinning, and the series
// `labelLayout` that sheds colliding on-chart data labels.

export const AXIS_LABEL_FONT_SIZE = 12;

// On-chart value labels (e.g. numbers above bars). Colors are caller-supplied
// since labels sit on varied backgrounds; defaults are AA-safe on light cards.
export const dataLabelStyle = {
  fontSize: 12,
  fontWeight: 600 as const,
};

// Series `labelLayout` that drops any on-chart data label which would collide
// with a neighbour already placed — so a dense value line (e.g. a 6–12-point
// currency series) sheds the overlapping labels instead of overprinting them
// into an illegible blob, keeping the legible ones. Spread onto a series'
// `labelLayout` wherever it shows per-datapoint value labels.
export const hideOverlapLabels = { hideOverlap: true } as const;

// Returns rotation + interval for a category axis so labels stay legible at
// 12px instead of overlapping or shrinking. Use on dense / compact charts.
export function denseAxisLabel(
  count: number,
  compact = false,
): { rotate: number; interval: number } {
  const threshold = compact ? 6 : 9;
  if (count <= threshold) {
    return { rotate: 0, interval: 0 };
  }
  const rotate = compact ? 40 : 30;
  const interval = Math.max(0, Math.ceil(count / (compact ? 5 : 8)) - 1);
  return { rotate, interval };
}
